import * as Yup from "yup";

export const initialValues = {code: ""};

export const validationSchema = Yup.object({
    code: Yup.string().required("کد ورود را وارد کنید")
});
